import { useContext } from 'react';
import Loading from '@/components/general/Loading';
import candidatePagesContext from '@/contexts/candidatePagesContext';
import CandidateNotes from './CandidateNotes.component';

const CandidateNotesPage = function (): JSX.Element {
  const { candidate, refetchCandidate } = useContext(candidatePagesContext);

  if (!candidate) {
    return <Loading fullPage />;
  }

  return <CandidateNotes refetchCandidate={refetchCandidate} candidate={candidate} />;
};

export default CandidateNotesPage;
